import { Btn } from "@/ui/btn/Btn";
import { Dropdown } from "@/ui/dropdown/Dropdown";
import { Icon } from "@/ui/icon/Icon";
import { Menu } from "@/ui/menu/Menu";
import { useCalculator } from "../../hooks/useCalculator";
import type { Calc } from "../../types";

interface CalculatorSelectProps {
  className?: string;
  moduleId: string;
  select: Calc.Form.Select;
}

export const CalculatorSelect: React.FC<CalculatorSelectProps> = ({
  className,
  moduleId,
  select,
}) => {
  const selectedOptionId = useCalculator(
    (state) =>
      state.modules.get(moduleId)?.values?.get(select.id) ?? select.value,
  );
  const setModuleValue = useCalculator((state) => state.setModuleValue);
  const selectedOption = select.options.find(
    (option) => option.id === selectedOptionId,
  );

  return (
    <Dropdown className={className}>
      <Dropdown.Toggle>
        <Dropdown.Context.Consumer>
          {(context) => (
            <Btn
              type="select"
              icon={select.icon}
              text={selectedOption?.title}
              endIcon="arrow_down_24px_regular"
              active={context.open}
              color="stroke-dark"
              size="sm"
            />
          )}
        </Dropdown.Context.Consumer>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Context.Consumer>
          {(context) => (
            <Menu size="sm">
              <Menu.Group>
                {select.options.map((option, index) => (
                  <Menu.Item
                    key={index}
                    active={option === selectedOption}
                    onClick={() => {
                      setModuleValue(moduleId, select.id, option.id);
                      context.close();
                    }}
                  >
                    <Icon name={select.icon} size={20} />
                    <Menu.Text>{option.title}</Menu.Text>
                  </Menu.Item>
                ))}
              </Menu.Group>
            </Menu>
          )}
        </Dropdown.Context.Consumer>
      </Dropdown.Menu>
    </Dropdown>
  );
};
